import { Suspense, useLayoutEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Bot, useBotMethods, getRobot } from '@mygpt/app';
import { CloningTip } from '@/components/Datasets/CloningTip';
import FallBack from '@/components/SuspenseFallBack';
import { BotRoutes } from '@/routes';
import { useGPTStore } from '@/store';
import { useDatasetStore } from '@/store/dataset';

const BotPage = () => {
  const { id } = useParams();
  Bot.setDefaultBotId(id);
  const { clearBot, setBotId } = useBotMethods();
  const { resetRobotInfo, setRobotInfo, userInfo, assetScope } = useGPTStore();
  const { setIsCloning } = useDatasetStore();
  const isLocalMode = import.meta.env.VITE_MODE === 'local';
  const isCloudEnterprise = !isLocalMode && !!assetScope;
  useLayoutEffect(() => {
    id && setBotId(id);
    id &&
      getRobot({ aiId: id }).then((res) => {
        setRobotInfo(res.data);
        setIsCloning(
          !!res.data.datasets?.some((item) => ['cloning_target', 'cloning_source'].includes(item.data_status))
        );
        // Cloud个人模式下，非自己的bot跳转到assist页面；企业模式下不跳转（参考本地部署逻辑）
        if (userInfo && res.data.user.user_id !== userInfo.user_id && !isLocalMode && !isCloudEnterprise) {
          window.location.replace(window.location.href.replace('/bot/', '/assist/'));
        }
      });

    return () => {
      resetRobotInfo();
      clearBot();
      Bot.delDefaultBotId();
    };
  }, [clearBot, id, setBotId]);

  return (
    <Suspense fallback={<FallBack />}>
      <BotRoutes />
      <CloningTip />
    </Suspense>
  );
};

export default BotPage;
